import React, { useEffect, useState } from 'react'
import Overview from './components/Aboutus/Overview';
import Banner from "./components/Banner/Index";
import BusinessEnquiry from "./components/Forms/Enquiry";
import CallbackBannerForm from "./components/Forms/CallbackBannerForm";
import './components/Aboutus/index.css';
// import pageData from './Json/outsource.json'
import Outsourcecontent from './components/OutSource/Outsourcecontent';
import Customized from './components/OutSource/Customized';
import GallerySlider from './components/Gallery/GallerySlider'
import axios from 'axios';
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";

const Outsource = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/outsource_bottling.php`);
        setPageData(response.data);
      }
      catch (err) {
        setError(err.message);
      }
      finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  if (loading) return (
    <div className="preloader flex-center">
      <CircularProgress size={24} />
    </div>
  );
  if (error) return (
    <div>Error: An error occurred while fetching data</div>
  )
  if (!pageData) return <p>Data not found.</p>;
  const { bannerData, overview, whyOutsource, sections, gallery } = pageData
  return (
    <main>
      <Banner
        Data={bannerData[0]}
        ImageHeight={'650'}
        MobileImageHeight={'520'}
        positionText={'left-text'}
        BannerClass='OutsouceBanner'
      >
        {/* <CallbackBannerForm /> */}
      </Banner>
      {overview && <Overview Data={overview} _class={'m-0'} />}
      {whyOutsource && <Outsourcecontent Data={whyOutsource} />}
      {sections[0] && <Customized Data={sections[0]} positionClass={'flex-center justify-content-end'} directionRow={'flex-direction align-items-center justify-content-between'} />}
      {sections[1] && <Customized Data={sections[1]} directionRow={'align-items-center'} />}
      {gallery && <GallerySlider Data={gallery} />}
      <BusinessEnquiry />
    </main>
  );
};

export default Outsource;